<template>
    <q-page>
        <router-view/>
    </q-page>
</template>

<script>

export default {
    name: "Clienti",
    data() {
        return {
        }
    },
}
</script>
